export default "__VITE_ASSET__BJPTBVD3__"